<template lang="pug">
#modal-only-desktop.modal.modal-lg.fade(tabindex='-1')
  .modal-dialog
    .modal-content
      .modal-body
        slot(name='message')
        img(src='@/assets/images/sent-desktop.svg', alt='menina sorrindo')
        button.btn.btn-primary.mt-5.w-100(
          type='button',
          data-bs-dismiss='modal',
          aria-label='Fechar'
        )
          Icon.me-2(name='thumbs-up')
          span Ok. Entendi
        button.btn.btn-outline-info.mt-3.w-100(
          type='button',
          @click='sendLink'
        )
          Icon(name='share-nodes')
          span.ms-2 Compartilhar link
button.btn-mobile.btn.btn-primary.mt-3(
  type='button',
  data-bs-target='#modal-only-desktop',
  data-bs-toggle='modal'
)
  Icon.me-2(name='download')
  span Baixar driver
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { mapActions } from 'pinia'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'

  export default defineComponent({
    name: 'ModalTokenComponent',
    components: {
      Icon,
    },
    data: () => ({
      teste: '',
    }),
    beforeCreate() {
      this.teste = window.location.href
    },
    methods: {
      ...mapActions(useToastGlobal, ['toggleToastGlobal']),
      async sendLink() {
        try {
          const shareData = {
            url: this.teste,
          }
          await navigator.share(shareData)
        } catch (_error) {
          this.toggleToastGlobal({
            isShow: true,
            type: 'info',
            message: 'Link não enviado',
          })
        }
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .btn-mobile
    display: none !important

  @media screen and (max-width: 768px)
    .btn-mobile
      display: block !important
</style>
